import React from "react";
import styles from "./shimmer.module.css";

const Shimmer = ({ height = "100%", borderRadius = "6px" }) => {
  return (
    <div
      className={styles.shimmerWrapper}
      style={{ height, borderRadius }}
    >
      <div className={styles.shimmer}></div>
    </div>
  );
};

export default Shimmer;
